import { render, staticRenderFns } from "./balanceRecharge.vue?vue&type=template&id=64c2196f&scoped=true&"
import script from "./balanceRecharge.vue?vue&type=script&lang=js&"
export * from "./balanceRecharge.vue?vue&type=script&lang=js&"
import style0 from "./balanceRecharge.vue?vue&type=style&index=0&id=64c2196f&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64c2196f",
  null
  
)

export default component.exports